var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRuler = function SvgRuler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ruler_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 26.3 14.2",
    style: {
      enableBackground: "new 0 0 26.3 14.2"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".ruler_svg__st1{stroke-linecap:round;stroke-miterlimit:10}")), /*#__PURE__*/React.createElement("path", {
    d: "M23.4 13.2H2.8c-1 0-1.8-.8-1.8-1.8V2.8C1 1.8 1.8 1 2.8 1h20.6c1 0 1.8.8 1.8 1.8v8.5c.1 1.1-.7 1.9-1.8 1.9z",
    style: {
      strokeMiterlimit: 10
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ruler_svg__st1",
    d: "M5.7 8.7V13M15.8 8.7V13M10.9 7.6v5.2M21 7.6v5.2"
  })));
};
export default SvgRuler;